<template>
  <span>
    <span data-toggle='modal' :data-target="'#' + modalId">
      <slot name='button' style="cursor: pointer;"></slot>
    </span>
    <div class='modal fade' @click="$event.stopPropagation()" :id="modalId">
      <div class='modal-dialog' role='document' :style="modalDialogStyle">
        <div class='modal-content' style="width: 100%; height: 100%;">
          <button v-if="showCloseBtn" type='button' class='close' data-dismiss='modal' aria-label='Close'>
            <span aria-hidden='true'>&times;</span>
          </button>
          <div class='modal-body' style="width: 100%; height: 100%;">
            <slot name='content'></slot>
          </div>
        </div>
      </div>
    </div>
    <Loading v-show="isLoading"></Loading>
  </span>
</template>
<script>
import $ from 'jquery'
import Loading from '@/components/Utility/Loading.vue'

export default {
  components: {
    Loading
  },
  props: {
    id: {
      type: String,
      default: 'modal'
    },
    showCloseBtn: {
      type: Boolean,
      default: false
    },
    savePromise: {
      type: Function,
      default: () => {}
    },
    prepareFunc: {
      type: Function,
      default: () => {}
    },
    oneTimeFunc: {
      type: Function,
      default: () => {}
    },
    haveChange: {
      type: Function,
      default: () => false
    },
    modalDialogStyle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      confirm: true,
      modalId: this.updateModalId(),
      isLoading: false
    }
  },
  computed: {
    modal: function () {
      return $(`#${this.modalId}`)
    },
    form: function () {
      return this.modal.find('form')[0]
    }
  },
  methods: {
    updateModalId: function () {
      let numberic = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let randomString = function (n) {
        let result = ''
        for (var i = 0; i < 10; i++) {
          result += numberic.charAt(Math.floor(Math.random() * numberic.length))
        }
        return result
      }
      let id = this.id
      // modalId = randomString(10)
      // $('#fsd')
      return id + '_' + randomString(10)
      // console.log($(`#${id}`))
      // do {
      //   id = id + '_' + randomString(10)
      // } while ($(`#${id}`).length > 1)
      // return id
    },
    open: function () {
      this.modal.modal('show')
    },
    close: function () {
      this.modal.modal('hide')
    }
  },
  mounted () {
    this.$nextTick(function () {
      // make sure no duplicate modal with same id
      while (this.modal.length > 1) {
        this.modalId = this.updateModalId()
      }

      var runHandling
      this.oneTimeFunc(this.modal)
      $('body').attr('have_change', 'false')
      // let loader=new Loader();
      // loader.prepare();
      this.modal.on('show.bs.modal', (e) => {
        /* The prepare function is used to set the initial value.
         * This will fire the keypress and change event hendler
         * We need to reset the have_change attribute after the prepare function
         */
        runHandling = true
        this.prepareFunc(this.modal, e)
        $('body').attr('have_change', 'false')
        // console.log(prepareFunc)
      })
      this.modal.find('.save-btn').on('click', function (e) {
        $(this).prop('is_click', true)
      }).prop('is_click', false)
      this.modal.find('form').find('input, textarea').on('keypress change', function (e) {
        $('body').attr('have_change', 'true')
      })
      this.modal.find('form').find('select').on('change', function (e) {
        $('body').attr('have_change', 'true')
      })
      this.modal.on('hide.bs.modal', async (e) => {
        /**************************************************************************
         * this is async function since I want to do this callback after receiving response from server.
         * but this event will not wait. So we need to run the hide two time.
         * In the first time, we will stop the default behaviour and wait the result to decide if fire this event again.
         * In the second time the modal will hide
         **************************************************************************/
        var action
        if (!this.modal.find('.save-btn').prop('is_click')) {
          action = 'exit'
        } else {
          action = 'save'
          this.modal.find('.save-btn').prop('is_click', false)
        }
        // run_handling=!run_handling;
        if (!runHandling) {
          return
        } else {
          e.preventDefault()
        }
        // the following is the handling, so it will not run in the next time by default.
        try {
          runHandling = false
          switch (action) {
            case 'save':
            // loader.show()
              this.isLoading = true
              var success = await this.savePromise(this.modal, e)
              this.isLoading = false
              // loader.hide()
              if (!success) {
                runHandling = true
              } else {
                this.modal.modal('hide')
              }
              break
            case 'exit':
              if (($('body').attr('have_change') === 'true' || this.haveChange()) && !confirm('確定關閉')) {
                runHandling = true
              } else {
                this.modal.modal('hide')
              }
              break
          }
        } catch (err) {
          console.error(err)
          runHandling = true
          this.isLoading = false
        }
        // if(!e.isDefaultPrevented()){
        //  $('body').attr('have_change', 'false');
        // }
      })

      // console.log(this.modalId)
      // console.log($(`#${this.modalId}`))
      // $(`#${this.modalId}`).on('shown.bs.modal', (e) => {
      //   this.confirm = true
      // })
      // $(`#${this.modalId}`).on('hide.bs.modal', (e) => {
      //   if (this.confirm) {
      //     return confirm('確定關閉')
      //   }
      // })
      // $(`#${this.modalId}`).find('.save-btn').on('click', (e) => {
      //   console.log('save btn click')
      //   this.confirm = false
      //   this.$emit('save', (a) => {
      //     alert('成功')
      //     console.log('success')
      //     console.log($(`#${this.modalId}`))
      //     $(`#${this.modalId}`).modal('hide')
      //   }, (a) => {
      //     alert('失敗')
      //     console.log('fail')
      //     console.log($(`#${this.modalId}`))
      //     $(`#${this.modalId}`).modal('hide')
      //   })
      // })
    })
    // $(`#${this.modalId}`).find('.cancel-btn').on('click', function (e) {
    //   this.confirm = false
    // })
  }
}
</script>
